class CustomCombobox {
  constructor(container) {
    if (!container) {
      return;
    }

    this.container = container;

    this.currentOptionElement = this.container.querySelector(this.selectors.control);

    this.onComboboxClicked = this.onComboboxClick.bind(this);
    this.onComboboxKeydowned = this.onComboboxKeydown.bind(this);

    this.onOptionClicked = this.onOptionClick.bind(this);

    document.addEventListener("click", this.onComboboxClicked);
    document.addEventListener("keydown", this.onComboboxKeydowned);

    this.container.customDelegate(
      "click",
      this.selectors.option,
      this.onOptionClicked
    );
  }

  selectors = {
    control: "[data-custom-combobox-control]",
    option: "[role='option']",
    optionContent: "[data-custom-combobox-option-content]",
  };

  modifiers = {
    active: "active"
  };

  onComboboxClick(event) {
    const isComboboxControlClicked = event.target.closest(this.selectors.control);

    if (!isComboboxControlClicked) {
      this.closeCombobox();
      return;
    }

    this.toggleCombobox();
  }

  onComboboxKeydown(event) {
    if (event.keyCode === 27) {
      this.closeCombobox();
    }
  }

  onOptionClick(event) {
    event.stopPropagation();

    const currentOption = event.target.closest(this.selectors.option);

    this.selectOption(currentOption);
    this.closeCombobox();
  }

  toggleCombobox() {
    if (this.container.classList.contains(this.modifiers.active)) {
      this.closeCombobox();
      return;
    }

    this.container.classList.add(this.modifiers.active);
  }

  closeCombobox() {
    this.container.classList.remove(this.modifiers.active);
  }

  selectOption(currentOption) {
    const content = currentOption.querySelector(this.selectors.optionContent);

    this.currentOptionElement.innerHTML = content.outerHTML;
  }
}

function initCustomCombobox(selector = "[data-custom-combobox]") {
  const containers = document.querySelectorAll(selector);

  if (!containers.length) {
    return;
  }

  Array.from(containers).forEach(function (container) {
    new CustomCombobox(container);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initCustomCombobox();
});
